import { Paper, styled as muiStyled } from "@mui/material";
import styled from "styled-components";

import lowPoly from "@/assets/low-poly-grid.png";
import futVector from "@/assets/football-vector.png";

export const MainContainer = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.bottomColor};
`;

export const ContentWrapper = styled.section`
  flex: 1;
  position: relative;
  z-index: 2;
`;

export const LogoWrapper = styled.div`
  h1 {
    color: ${(props) => props.theme.primary};
    font-size: 3rem;
  }
  img {
    max-width: 100%;
    width: 250px;
  }
`;

export const BackgroundVector = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: url(${futVector});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: contain;
`;

export const QuoteContainer = styled.div`
  position: absolute;
  right: 80px;
  top: 80px;

  h2 {
    max-width: 300px;
    font-weight: 400;
    letter-spacing: 0.64px;
  }

  p {
    text-align: right;
    margin-top: 10px;
  }

  img {
    position: relative;
    top: 30px;
    left: -35px;
    z-index: -1;
  }

  @media (max-width: 950px) {
    display: none;
  }
`;

export const ContainerCont = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  margin-left: 80px;
  @media (max-width: 950px) {
    margin-left: 0;
    align-items: flex-start;
  }
`;

export const FormContainer = styled.div`
  position: relative;
  max-width: 400px;
  @media (max-width: 950px) {
    max-width: none;
    width: 100%;
    height: 100%;
  }
`;

export const InputsContainer = styled.div`
  position: relative;
  background: linear-gradient(200deg, transparent 20%, #242C35 50%);
  overflow: hidden;
  color: #fff;
  max-width: 400px;
  padding: 40px 30px;
  clip-path: polygon(0 100%, 91% 100%, 100% 92%, 100% 0, 9% 0, 0 8%);

  h1 {
    margin-bottom: 30px;
  }

  span {
    color: #04e762;
  }

  p {
    margin-top: 10px;
    margin-bottom: 5px;
  }
  @media (max-width: 950px) {
    clip-path: none;
    max-width: none;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const InputCover = styled.div`
  position: relative;
  z-index: 1;
`;

export const ResetPassTxt = styled.p`
  color: ${(props) => props.theme.primary};
  font-size: 0.9rem;
  cursor: pointer;
  user-select: none;
  margin: 5px 0 15px !important;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 10px;
    font-size: 1.2rem;
    cursor: pointer;
  }

  h1 {
    margin-bottom: 0;
  }
`;

export const InputsFooter = styled.div`
  span {
    color: ${(props) => props.theme.fontColor}80;
  }
  a {
    color: ${(props) => props.theme.primary};
  }
`;

export const LoginBackground = styled.div`
  position: absolute;
  top: 0px;
  background: url(${lowPoly}), lightgray 50% / cover no-repeat;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  z-index: -1;
  clip-path: polygon(0 100%, 91% 100%, 100% 92%, 100% 0, 9% 0, 0 8%);
  @media (max-width: 950px) {
    clip-path: none;
  }
`;

export const OuterLogin = styled.div`
  display: flex;
  justify-content: space-around;

  margin-bottom: 15px;
  button {
    display: flex;
    align-items: center;
    border-radius: 8px;
    border: 1px solid #484747;
    color: #cbc5cf;
    background: #333;
    padding: 16px 40px;
  }

  button:last-child {
    margin-left: 10px;
  }

  svg {
    margin-right: 5px;
  }

  @media (max-width: 400px) {
    button {
      padding: 15px 25px;
    }
  }
`;

export const H3Styled = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  color: ${(props) => props.theme.primary};
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

export const ModalWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  position: relative;
  max-width: 430px;
  margin: 0 10px;
  background-color: ${(props) => props.theme.backgroundColor};
  padding: 20px 15px;
  border-radius: 5px;
  transition: all 400ms ease-in-out;
`;

export const ModalActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalButton = styled.div`
  display: flex;
  padding: 0 5px;
  cursor: pointer;
  user-select: none;
  margin-bottom: 10px;
  span,
  svg {
    font-size: 20px;
  }
`;

export const ValidSignature = styled.div`
  p {
    margin: 20px 0;
  }
`;

export const PaymentContainer = styled.form`
  margin: 15px 0px 5px;
`;

export const RadioContainer = styled.label`
  display: flex;
`;

export const RadioNameContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
